module.exports = __webpack_public_path__ + "img/audio.a5706847.png";